import { requiredRule, ValidateOptions } from '@.hooks';

import { ProductData } from './types';

export const validateOptions = (brandNameEnRequired: boolean): ValidateOptions<ProductData> => ({
    name: {
        type: 'lingual',
        required: requiredRule,
    },
    description: {
        type: 'lingual',
    },
    brand_id: {
        type: 'number',
        required: requiredRule,
    },
    brand_name_en: {
        type: 'string',
        required: brandNameEnRequired ? requiredRule : undefined,
    },
    product_type_id: {
        type: 'number',
        required: requiredRule,
    },
    ages_ids: {
        type: 'number[]',
    },
    sexes_ids: {
        type: 'number[]',
        required: requiredRule,
    },
    strength_id: {
        type: 'number',
        required: requiredRule,
    },
    occasions_ids: {
        type: 'number[]',
        required: requiredRule,
    },
    ingredients_ids: {
        type: 'number[]',
        required: requiredRule,
    },
    characters_ids: {
        type: 'number[]',
        required: requiredRule,
    },
    tags_ids: {
        type: 'number[]',
    },
    images_ids: {
        type: 'number[]',
    },
});
